import { lightTheme } from "../../../theme/theme";
type Theme = typeof lightTheme;

export const OurWorkDetailsStyles = (theme: Theme, isMobile: boolean) => {
  const accent = `var(--accent, ${theme.primary})`;

  return {
    breadcrumbWrap: {
      maxWidth: 1140,
      margin: "0 auto",
      padding: "16px",
    },
    backLink: {
      display: "inline-flex",
      alignItems: "center",
      gap: 8,
      padding: "8px 12px",
      borderRadius: 12,
      border: `1px solid ${theme.primary}33`,
      background: `${theme.primary}10`,
      color: theme.text,
      textDecoration: "none",
      fontSize: 14,
      fontWeight: 600,
    },

    hero: {
      background: `linear-gradient(180deg, ${accent}14 0%, transparent 70%)`,
    },
    heroInner: {
      maxWidth: 1140,
      margin: "0 auto",
      padding: "24px 16px 32px",
      display: "grid",
      gridTemplateColumns: isMobile ? "1fr" : "1.1fr .9fr",
      gap: 24,
      alignItems: "center",
    },

    title: {
      margin: "8px 0 10px",
      fontFamily: '"Playfair Display", Georgia, serif',
      fontWeight: 700,
      fontStyle: "italic",
      fontSize: "clamp(26px, 4.8vw, 42px)",
      lineHeight: 1.12,
      color: theme.text,
    },

    metaRow: {
      display: "flex",
      flexWrap: "wrap" as const,
      gap: 8,
      alignItems: "center",
      opacity: 0.9,
      fontSize: 14,
      marginBottom: 10,
    },
    metaDot: { opacity: 0.6 },

    lead: {
      fontSize: 16,
      lineHeight: 1.6,
      color: theme.text,
      margin: "6px 0 14px",
      opacity: 0.95,
    },

    statsRow: {
      display: "flex",
      flexWrap: "wrap" as const,
      gap: 8,
    },
    statPill: {
      display: "inline-flex",
      alignItems: "center",
      gap: 6,
      padding: "6px 0px",
      borderRadius: 999,
      border: `1px solid ${theme.primary}33`,
      background: `${theme.primary}08`,
      fontSize: 13,
      fontWeight: 600,
      color: theme.text,
    },

    mediaBox: {
      borderRadius: 16,
      overflow: "hidden",
      border: `1px solid ${theme.primary}33`,
      boxShadow: "0 10px 30px rgba(0,0,0,.12)",
      background: theme.card ?? "#fff",
    },
    media: {
      display: "block",
      width: "100%",
      height: "100%",
      objectFit: "cover" as const,
      aspectRatio: "16 / 10",
    },

    section: { maxWidth: 1140, margin: "8px auto 40px", padding: "0 16px" },
    sectionTitle: {
      fontFamily: '"Playfair Display", Georgia, serif',
      fontWeight: 600,
      fontStyle: "italic",
      fontSize: "clamp(20px, 3vw, 28px)",
      marginBottom: 12,
    },
  } as const;
};
